import { ComponentProps, useCallback, useState } from "react";
import { Modal, ModalContent } from "../../../ui/modal";
import { ModalData, ModalShowParams } from "../types";

type IModalProps = ComponentProps<typeof Modal>;
type IModalContentProps = ComponentProps<typeof ModalContent>;

export function useModal() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState<ModalData>({
    children: null,
  });

  const [options, setOptions] = useState<
    Omit<IModalProps, "onClose" | "isOpen" | "children">
  >({});
  const [enableSwipeToDismiss, setEnableSwipeToDismiss] = useState<
    boolean | undefined
  >(undefined);
  const [contentProps, setContentProps] = useState<
    Omit<IModalContentProps, "children">
  >({});

  const show = useCallback((params: ModalShowParams) => {
    const {
      children,
      contentProps: newContentProps,
      enableSwipeToDismiss: newEnableSwipeToDismiss,
      ...newOptions
    } = params;
    setData({
      children: children ?? null,
    });
    setOptions(newOptions);
    newContentProps && setContentProps(newContentProps);
    setEnableSwipeToDismiss(newEnableSwipeToDismiss);
    setIsVisible(true);
  }, []);

  const hide = useCallback(() => {
    setIsVisible(false);
    setData({
      children: null,
    });
    setOptions({});
    setContentProps({});
    setEnableSwipeToDismiss(false);
  }, []);

  return {
    isVisible,
    show,
    hide,
    data,
    options,
    contentProps,
    enableSwipeToDismiss,
  };
}
